import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HttpStatusCode } from "axios";

import { CATEGORY_ALIAS } from "../../../types/talk";

import { onLikePost } from "../../../libs/talk";

import { TalkListItem, getTalkPostList } from "../../../services/talkServices";

import { useUserContext } from "../../../contexts/userContext";
import { useSandiTalk } from "../../../contexts/boardContext";

import useSimplePopup from "../../../hooks/useSimplePopup";
import useFullScreenLoading from "../../../hooks/useFullScreenLoading";

import StickyHeader from "../../../components/Layout/StickyHeader";
import PostList from "../../../components/Talk/PostList";

type Props = {};

export default function MyInfoFaq(props: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [user] = useUserContext();
  const [isLoading, setIsLoading] = useState(true);
  const loadingComponent = useFullScreenLoading({ isLoading });
  const [postList, setPostList] = useState<TalkListItem[]>([]);
  const [simplePopupComponent, { open }] = useSimplePopup({});
  const [talk] = useSandiTalk();

  const loadPostList = async () => {
    setIsLoading(true);
    let additionalParams = "";
    if (talk.sort) {
      additionalParams += `&sort=${talk.sort}`;
    }
    if (talk.dateRange) {
      additionalParams += `&dateRange=${talk.dateRange}`;
    }
    try {
      const result = await getTalkPostList(
        `/v2/app/pinelife/post/list?category=${CATEGORY_ALIAS.SANDI_FAQ}` +
          (additionalParams ?? "")
      );
      if (result.status === HttpStatusCode.Ok) {
        setPostList(result.data.items);
      }
    } catch (e: any) {
      if (e?.response?.data?.error) {
        open(e?.response?.data?.error);
      } else {
        open("FAQ를 불러오는데 실패했습니다.\n잠시 후 다시 시도해주세요.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user.isLoading) return;
    setIsLoading(true);
    loadPostList();
    setIsLoading(false);
  }, [user.isLoading]);

  return (
    <div>
      {loadingComponent}
      <StickyHeader
        title="샌디 FAQ"
        onBackClick={() => navigate(params.get("backHistory") ?? "/myinfo")}
        className="px-5"
      />

      <PostList
        isFaq={true}
        postList={postList}
        onClickLike={(postId) => {
          setPostList((prev) =>
            prev.map((post) =>
              post.lifePostId === postId ? onLikePost(post, user) : post
            )
          );
          loadPostList();
        }}
        storeList={[]}
        emptyMessage="FAQ가 없습니다."
        parentUrl="/myinfo/faq"
      />

      {simplePopupComponent}
    </div>
  );
}
